<template>
    <article class="cause-item partner-item" :id="cause.id">
        <div class="cause-item__feature cursor-pointer" v-if="cause.img !== undefined && cause.img.length > 0">
            <div class="cause-filter-container relative">
                <ul class="cause-filter flex flex-nowrap" @click="clickHandler(cause)">
                    <li v-for="(url, index) in getNposJson(cause.img)" :key="index">
                        <div class="cause-item__slide relative">
                            <img loading="lazy" class="object-center object-cover" :src="getNposImage(url)"
                                :alt="getNposContent('title') || $t('Cause')" />
                        </div>
                    </li>
                </ul>
            </div>
        </div>
        <div class="cause-item__body">
            <header v-if="cause.title !== undefined" class="mb-6">
                <h2 class="cause-item__title text-text font-bold cursor-pointer" @click="clickHandler(cause)">
                    {{ getNposContent("title") }}
                </h2>

                <div class="flex justify-between">
                    <div class="partner-type text-14 tracking-normal text-content" v-if="
                        cause.categories &&
                        cause.categories.name !== undefined &&
                        cause.categories.name
                    ">
                        {{ getLocalizationData(cause.categories.name) }}
                    </div>
                    <div v-else></div>

                    <button v-if="cause.max_discount > 0"
                        class="p-1 flex btn-bgr-accent text-white justify-center border-0 btn-discount">
                        <img class="mx-1" :srcset="
                            `${$store.state.appUrl}/img/pwa/dashboard-icons/tag.svg, ${$store.state.appUrl}/img/pwa/dashboard-icons/tag.svg`
                        " :src="`${$store.state.appUrl}/img/pwa/dashboard-icons/tag.svg`" alt="Discount Tag"
                            width="14px" height="auto" />
                        <!-- <PartnerIcons icon="tag" classes="mr-3" /> -->
                        <span class="px-2 text-12">Save {{ cause.max_discount }}% Off</span>
                    </button>
                </div>
            </header>

            <div class="cause-item__content mb-8">
                <ul>
                    <li class="text-12 tracking-normal text-cause_text mb-1 flex items-center">
                        <PartnerIcons icon="clock" classes="icon-color mr-3" />
                        <span class="pr-1" :class="{
                            'is-open': cause.is_open === 'Open',
                            'is-close': cause.is_open !== 'Open',
                        }" v-if="cause.is_open !== undefined">{{ openClose }}
                        </span>
                        {{ todayTimeOpen }}
                    </li>
                    <!--                    <li-->
                    <!--                        class="text-12 tracking-normal text-cause_text mb-1 flex items-center"-->
                    <!--                    >-->
                    <!--                        <PartnerIcons-->
                    <!--                            icon="price"-->
                    <!--                            classes="text-primary mr-3"-->
                    <!--                        />-->
                    <!--                        {{ price }}-->
                    <!--                    </li>-->
                    <!-- <li class="text-12 tracking-normal text-cause_text mb-1 flex items-center">
                        <PartnerIcons icon="discount" classes="text-primary mr-3" />
                        {{ discount }}
                    </li> -->
                    <li v-if="cause.address !== undefined"
                        class="text-12 tracking-normal text-cause_text mb-1 flex items-center cursor-pointer">
                        <PartnerIcons icon="address" classes="icon-color mr-3" />
                        <a v-if="mapLink" :href="mapLink" target="_blank" class="text-link">
                            {{ cause.address }}
                        </a>
                        <span v-else class="text-12 tracking-normal text-cause_text">
                            {{ cause.address }}
                        </span>

                    </li>
                    <li>
                        <ul>
                            <li v-for="(phone, index) in getNposJson(
                                cause.phone,
                            )" :key="index" v-if="phone"
                                class="text-12 tracking-normal text-cause_text mb-1 flex items-center">
                                <PartnerIcons icon="phone" classes="icon-color mr-3" />
                                <a :href="`tel:${phone}`">{{ phone }}</a>
                            </li>
                        </ul>
                    </li>
                </ul>
            </div>

            <button type="button"
                class="cause-item__btn btn-color text-16 text-center flex justify-center items-center m-auto px-8"
                @click="openQrReader">
                <PartnerIcons icon="qr" classes="color-white mr-3 table" /><span>{{ $t("Scan to get offer") }}</span>
            </button>
        </div>
        <QrCodeReader v-if="qrReaderVisible" @closeQrReader="closeQrReader" :partner-id="cause.id"
            :partner-name="getNposContent('title')" />
    </article>
</template>

<script>
import mixins from "../../config/mixins";
import PartnerIcons from "../Icons/PartnersIcons";
import QrCodeReader from "./QrCodeReader_new";

export default {
    name: "PartnerItem",
    components: { QrCodeReader, PartnerIcons },
    mixins: [mixins.npos],

    props: ["cause", "clickHandler", "isSingle"],

    data: function () {
        return {
            locale: this.$i18n.locale,
            qrReaderVisible: false,
            timeBoardClose: {},
        };
    },

    computed: {
        openClose: function () {
            if (!!this.cause.is_open) {
                if (this.cause.is_open === "Open") {
                    return this.$t("Open now");
                }

                if (this.cause.is_open === "Close") {
                    return this.$t("Closed");
                }
            }

            return "";
        },
        mapLink: function () {

            if (this.cause.location) {
                const coords = this.getNposJson(this.cause.location);
                if (!!coords.lat && !!coords.lng) {
                    return (
                        "https://maps.google.com/maps?saddr=" +
                        coords.lat +
                        "," +
                        coords.lng +
                        "&daddr=" +
                        this.cause.address
                    );
                }
            }
            return "";
        },
    },

    methods: {
        openQrReader: function () {
            this.$setState("isNavigation", false);
            this.qrReaderVisible = true;
        },
        closeQrReader: function () {
            this.qrReaderVisible = false;
            this.$setState("isNavigation", true);
        },
    },
};
</script>
